"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface QuoteBandCopy {
  eyebrow: string;
  heading: string;
  subtext: string;
}
const copyData: Record<Lang, QuoteBandCopy> = {
  en: {
    eyebrow: "B2B Industrial Filtration Mesh",
    heading: "Have a Specific Filtration Requirement?",
    subtext: "Application conditions, existing specifications, or drawings can be shared for product matching."
  },
  zh: {
    eyebrow: "B2B 工业过滤丝网",
    heading: "有特定的过滤需求吗？",
    subtext: "可以共享应用条件、现有规格或图纸以进行产品匹配。"
  },
  es: {
    eyebrow: "Malla de filtración industrial B2B",
    heading: "¿Tiene un requisito de filtración específico?",
    subtext: "Se pueden compartir las condiciones de aplicación, especificaciones existentes o planos para la selección del producto."
  },
  de: {
    eyebrow: "B2B-Industriefiltergewebe",
    heading: "Haben Sie eine spezifische Filtrationsanforderung?",
    subtext: "Einsatzbedingungen, bestehende Spezifikationen oder Zeichnungen können für den Produktabgleich bereitgestellt werden."
  },
  fr: {
    eyebrow: "Toile de filtration industrielle B2B",
    heading: "Vous avez une exigence de filtration spécifique ?",
    subtext: "Les conditions d'application, spécifications existantes ou plans peuvent être partagés pour la sélection des produits."
  },
  pt: {
    eyebrow: "Malha de filtração industrial B2B",
    heading: "Tem um requisito específico de filtração?",
    subtext: "Condições de aplicação, especificações existentes ou desenhos podem ser compartilhados para a correspondência do produto."
  }
};
export default function QuoteBand() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="quotectaband" eyebrow={content.eyebrow} heading={content.heading} lead={content.subtext} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: pick(lang, COMMON.contactUs),
    to: "/ContactPage"
  }} />;
}